{#if data && charity}
  {#if data.status === 'withdrawn'}
    <article class="message is-info">
      <div class="message-body">This charity withdrew its request.</div>
    </article>
  {:else if data.status === 'unsuccessful'}
    <article class="message is-warning">
      <div class="message-body">Request declined</div>
    </article>
  {:else if data.status === 'selected'}
    <article class="message is-success">
      <div class="message-body">
        <p>Awaiting confirmation from your selected charity.</p>
        <p>
          The charity's contact details will be shown as soon as the charity
          confirms.
        </p>
      </div>
    </article>
  {:else if data.status === 'matched'}
    <article class="message is-success">
      <div class="message-body">
        <p class="block">It's a match!</p>
        <p class="block">
          Now it's over to you to complete the donation by arranging collection
          or delivery.
        </p>
        <p class="block">
          We've sent an email to both you and the charity contact to get you
          started. If you need any assistance, please contact <a
            href="mailto:support@agoodthing.org.uk"
            >support@agoodthing.org.uk</a>
        </p>
        <!-- svelte-ignore a11y-missing-attribute -->
        <p class="block">
          When the item(s) have been sent or collected, please <a
            on:click={() => {
              $uiState.activeModal = {
                component: ConfirmComplete,
                props: { id: requestId }
              };
            }}>confirm the donation is complete</a
          >.
        </p>
      </div>
    </article>
  {/if}
  <nav class="level">
    <!-- Left side -->
    <div class="level-left level-can-wrap">
      <div class="level-item level-can-wrap">
        <h2 class="title">
          {charity.name}
          <RequestStatusTag status={data.status || 'new'} medium={true} />
        </h2>
      </div>
    </div>

    <!-- Right side -->
    <div class="level-right">
      {#if data.status == 'new'}
        <button
          class="button is-primary"
          on:click={() =>
            ($uiState.activeModal = {
              component: ConfirmSelect,
              props: { requestId }
            })}>Select charity</button>
        <button
          class="button is-secondary"
          style="margin-left: 10px"
          on:click={() =>
            ($uiState.activeModal = {
              component: DeclineSelect,
              props: { requestId }
            })}>Decline request</button>
      {:else if data.status == 'selected'}
        {#if $appState.user?.isAdmin}
        <button
          class="button is-secondary"
          style="margin-left: 10px"
          on:click={() =>
            ($uiState.activeModal = {
              component: DeclineSelect,
              props: { requestId }
            })}>Decline request (admin only)</button>
        {/if}
      {:else if data.status == 'unsuccessful'}
        {#if $appState.user?.isAdmin}
        <button
            class="button is-primary"
            on:click={() =>
              ($uiState.activeModal = {
                component: ConfirmSelect,
                props: { requestId }
              })}>Select charity (admin only)</button>
        {/if}
      {:else if data.status == 'matched'}
        <button
          class="button is-primary"
          on:click={() => {
            $uiState.activeModal = {
              component: ConfirmComplete,
              props: { id: requestId }
            };
          }}>Confirm donation complete</button>
      {/if}
    </div>
  </nav>

  {#if data.created}
    <div class="block has-text-grey-light">
      {#if data.status === 'interested'}
        Chat started
      {:else}
        Request made
      {/if}
      {dayjs().to(dayjs(data.created))}
      | Location is {$appState.company && $appState.company.location
        ? distance(data.charity.location, $appState.company.location)
        : 'nearby'}
    </div>
  {/if}

  {#if data.charity.highlight}
  <div class="block">
    <HighlightedTag highlight={data.charity.highlight} expanded/>
  </div>
  {/if}

  {#if data.message && !isChatEnabled}
    <p class="block">
      <LargeMessage>{data.message}</LargeMessage>
    </p>
  {/if}

  {#if data.status === 'matched' || data.status === 'completed' || data.status === 'failed'}
    <div>
      <span
        class="is-uppercase is-size-4 has-text-grey-light"
        style="vertical-align:middle;">Contact details</span>
    </div>

    <table class="table is-fullwidth">
      <thead>
        <tr>
          <th style="width:200px" />
          <th />
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Name</td>
          <td>
            {data.charity?.contact?.firstName}
            {data.charity?.contact?.lastName}
          </td>
        </tr>
        <tr>
          <td>Email</td>
          <td>{data.charity?.contact?.email}</td>
        </tr>
      </tbody>
    </table>
  {/if}
  {#if !isChatEnabled}
    <hr />
  {/if}

  {#if isChatEnabled}
    <div class="tabs">
      <ul>
        <li
          class:is-active={!showMessages}
          on:click={() => {
            if (showMessages) {
              showMessages = false;
            }
          }}>
          <!-- svelte-ignore a11y-missing-attribute -->
          <a> Charity Profile </a>
        </li>
        {#if data.messages && data.messages?.length > 0}
          <li
            class:is-active={showMessages}
            on:click={() => {
              if (!showMessages) {
                showMessages = true;
              }
            }}>
            <!-- svelte-ignore a11y-missing-attribute -->
            <a> Messages </a>
          </li>
        {/if}
      </ul>
    </div>
  {/if}

  {#if isChatEnabled && showMessages && data.messages}
    <Chat
      messageIds={data.messages ?? []}
      charityName={charity.name}
      companyName={$appState.company?.name} />
  {/if}

  {#if !showMessages || !isChatEnabled}
    {#if charity.type === 'EnglandAndWalesRegistered'}
      <EnglandWalesCharityFull {charity} />
    {:else if charity.type === 'ScotlandRegistered'}
      <ScotlandCharityFull {charity} />
    {:else if charity.type === 'NorthernIrelandRegistered'}
      <NorthernIrelandCharityFull {charity} />
    {:else if charity.type === 'CIC'}
      <CICFull {charity} />
    {:else if charity.type === 'CBS'}
      <CBSFull {charity} />
    {:else if charity.type === 'HMRCCharity'}
      <HMRCCharityFull {charity} />
    {:else}
      <UnregisteredCharityFull {charity} />
    {/if}
  {/if}
{/if}

{#if showToast}
  <div class="notification is-success">
    <button class="delete" on:click={() => (showToast = false)} />
    Offer created
  </div>
{/if}

<script lang="ts">
  export let requestId: RequestId;
  import _ from 'lodash';
  import getFeatureFlags from '../../../../../utils/getFeatureFlags';
  import { appState } from '../../../../../lib/appState';
  import { uiState } from '../../../../../lib/uiState';
  import { params, url } from '@sveltech/routify';
  import ConfirmSelect from './ConfirmSelect.svelte';
  import DeclineSelect from './DeclineSelect.svelte';
  import RequestStatusTag from '../../../../_components/RequestStatusTag.svelte';
  import HighlightedTag from '../../../_components/HighlightedTag.svelte';

  import ConfirmComplete from '../_components/ConfirmComplete.svelte';
  import EnglandWalesCharityFull from '../../../../_components/org_profiles/EnglandWalesCharityFull.svelte';
  import ScotlandCharityFull from '../../../../_components/org_profiles/ScotlandCharityFull.svelte';
  import NorthernIrelandCharityFull from '../../../../_components/org_profiles/NorthernIrelandCharityFull.svelte';
  import CICFull from '../../../../_components/org_profiles/CICFull.svelte';
  import CBSFull from '../../../../_components/org_profiles/CBSFull.svelte';
  import HMRCCharityFull from '../../../../_components/org_profiles/HMRCCharityFull.svelte';
  import UnregisteredCharityFull from '../../../../_components/org_profiles/UnregisteredCharityFull.svelte';
  import LargeMessage from '../../../../_components/LargeMessage.svelte';
  import dayjs from 'dayjs';
  import relativeTime from 'dayjs/plugin/relativeTime';
  dayjs.extend(relativeTime);

  import geoDist from 'geo-dist';
  import Chat from '../../../../_components/Chat.svelte';

  const { isChatEnabled } = getFeatureFlags();
  let offerId: string = $params['id'];

  let data: Request_v2, charity: Charity_v2;

  let showToast = false;
  let showMessages = false;

  let firebase = window.firebase;

  let messages: Message_v1[] = [];

  get();

  $: if (data) {
    getCharity(data.charity.id);
    getMessages();
  }

  async function get() {
    firebase
      .firestore()
      .collection('requests_v2')
      .doc(requestId)
      .onSnapshot((doc) => {
        data = doc.data() as Request_v2;
      });
  }

  function getMessages() {
    if (data.messages) {
      data.messages.forEach((messageId) => {
        firebase
          .firestore()
          .collection('messages_v1')
          .doc(messageId)
          .onSnapshot((doc) => {
            messages.push(doc.data() as Message_v1);
          });
      });
    }
  }

  async function getCharity(id: CharityId) {
    firebase
      .firestore()
      .collection('charities_v2')
      .doc(id)
      .onSnapshot((doc) => {
        charity = doc.data() as Charity_v2;
      });
  }

  function distance(point1: GeoPoint, point2: GeoPoint) {
    const km = geoDist(
      point1.latitude,
      point1.longitude,
      point2.latitude,
      point2.longitude
    );
    const miles = km * 0.6213712; // miles
    if (miles < 1) {
      return 'Within 1 mile';
    } else if (miles < 4.5) {
      return miles.toFixed(1) + ' miles away';
    } else {
      return Math.round(miles) + ' miles away';
    }
  }
</script>
